import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);


export const init = () => {

    ScrollTrigger.killAll()

    let cible = '.reveal'
    if (document.querySelector('.bloc-portfolio__actif')) {
        cible = '.bloc-portfolio__actif .reveal'
    }
    const reveals = document.querySelectorAll(cible);
    reveals.forEach((section, index) => {
        ScrollTrigger.create({
            trigger: section,
            id: index + 1,
            start: 'top 80%',
            end: 'bottom 80%',
            onEnter: () => {
                section.classList.remove('reveal')
            },
            onLeave: () => {
                self => self.disable()
            },
            onLeaveBack: self => self.disable(),
            markers: false // !! MARQUERUS
        })
    })

    let cible2 = '.reveal-trait'
    const reveals2 = document.querySelectorAll(cible2);
    reveals2.forEach((section, index) => {
        ScrollTrigger.create({
            trigger: section,
            id: index + 1,
            start: 'top 80%',
            end: 'bottom 80%',
            onEnter: () => {
                section.classList.remove('reveal-trait')
            },
            onLeave: () => {
                self => self.disable()
            },
            onLeaveBack: self => self.disable(),
            markers: false // !! MARQUERUS
        })
    })
    
}